import { createRouter, createWebHistory } from 'vue-router'
import { App } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'
import Analytics, { SCREEN_MAIN_MENU, SCREEN_MARKET_HOURS, SCREEN_TOP_5_BROKERS } from '@/services/Analytics'
import { ScreenOrientation, OrientationType } from '@capawesome/capacitor-screen-orientation'
import journeyService from '@/modules/journey/JourneyService'
import AuthService from '@/services/AuthService'
import AppService from '@/services/AppService'
import apiService from '@/services/ApiService'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/modules/core/Home.vue'),
    meta: {
      title: SCREEN_MAIN_MENU
    }
  },
  {
    path: '/trading',
    name: 'trading',
    component: () => import('@/modules/trading/Trading.vue'),
    props: true
  },
  {
    path: '/game',
    name: 'game',
    component: () => import('@/modules/game/Game.vue')
  },
  {
    path: '/quiz',
    name: 'quiz',
    component: () => import('@/modules/quiz/Quiz.vue')
  },
  {
    path: '/brokers',
    name: 'brokers',
    component: () => import('@/modules/brokers/Brokers.vue'),
    meta: {
      title: SCREEN_TOP_5_BROKERS
    }
  },
  {
    path: '/top5brokers',
    redirect: { name: 'brokers' }
  },
  {
    path: '/school',
    name: 'school',
    component: () => import('@/modules/school/School.vue'),
    redirect: { name: 'school.topics' },
    children: [
      {
        path: 'topics',
        name: 'school.topics',
        component: () => import('@/modules/school/Topics.vue')
      }
    ]
  },
  {
    path: '/school/lessons/:id',
    name: 'school.page',
    props: true,
    component:  () => import('@/modules/school/Page.vue')
  },
  {
    path: '/hours',
    name: 'hours',
    component: () => import('@/modules/hours/Hours.vue'),
    meta: {
      orientation: 'unlock',
      title: SCREEN_MARKET_HOURS
    }
  },
  {
    path: '/journey/current',
    name: 'journey.current',
    beforeEnter: async (to, from, next) => {
      try {
        const p = {
          user_id: AuthService.isAuth() ? AuthService.getAuthUser().id : undefined,
          app_instance_id: AppService.getAppId()
        }
        const { data: userJourneyDays } = await apiService.searchUserJourneyDays(p)
        const currentOrdinal = journeyService.getCurrentOrdinal(userJourneyDays)
        const isCompleted = userJourneyDays.some(d => d.journey_day_ordinal === currentOrdinal && d.completed_at)

        if (isCompleted) {
          next({ name: 'home' })
        } else {
          next({
            name: 'journey',
            params: { ordinal: currentOrdinal }
          });
        }
      } catch (e) {
        next({ name: 'home' })
      }
    }
  },
  {
    path: '/journey/:ordinal',
    name: 'journey',
    props: true,
    component: () => import('@/modules/journey/Journey.vue')
  }
]


const router = createRouter({
  history: createWebHistory(),
  // base: import.meta.env.BASE_URL,
  routes,
})

if (Capacitor.isNativePlatform()) {
  App.addListener('backButton', () => {
    if (router.currentRoute.name === 'home') {
      App.exitApp()
    } else {
      router.go(-1)
    }
  })

  App.addListener('appUrlOpen', (event) => {
    const url = new URL(event.url)
    // normalize path if domain is missing. eg. forexhero://top5brokers
    const path = (url.pathname || url.hostname).replace(/^\/\//, '')
    router.push('/' + path + url.search)
  })
}

router.beforeEach((to, from, next) => {
  // Handle screen orientation based on view
  if (Capacitor.isNativePlatform()) {
    if (to.meta?.orientation === 'unlock') {
      ScreenOrientation.unlock()
    } else {
      ScreenOrientation.lock({ type: OrientationType.PORTRAIT })
    }
  }

  // Set analytics data
  if (to.meta.title) {
    // console.log('---> Router setting screen name', to.meta.title)
    Analytics.setScreenName(to.meta.title)
  }

  next()
})

export default router
